import { servicedeskKnowledgeBaseAppLinksResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseAppLinksResource.tsx';
import { servicedeskKnowledgeBaseKbTopicsResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseKbTopicsResource.tsx';
import { servicedeskKnowledgeBaseAiDraftGenerateResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseAiDraftGenerateResource.tsx';
import { servicedeskKnowledgeBaseFetchProjectIssuesResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseFetchProjectIssuesResource.tsx';
import { servicedeskKnowledgeBaseThirdpartyConnectorsResource } from '@jira/router-resources__service-desk-knowledge-base/src/servicedeskKnowledgeBaseThirdpartyConnectorsResource.tsx';

import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getKBExperimentResources = (): RouteResource<any>[] => [
	servicedeskKnowledgeBaseAppLinksResource,
	servicedeskKnowledgeBaseKbTopicsResource,
	servicedeskKnowledgeBaseAiDraftGenerateResource,
	servicedeskKnowledgeBaseFetchProjectIssuesResource,
	servicedeskKnowledgeBaseThirdpartyConnectorsResource,
];
